import React from "react";

export default function HoliFrame6({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-6hol1{fill:#e85318}"}</style>
        </defs>
        <path
          d="M1487.55 1703.89c0 87.94-221.57 159.23-494.89 159.23s-494.9-71.29-494.9-159.23c0-29.63 25.15-57.37 68.96-81.13 26.45-14.33 59.68-27.22 98.29-38.2 2.54.23 5.11.35 7.71.35h614.42c7.95 0 15.64-1.11 22.93-3.18 22.02 5.92 42.41 12.46 60.93 19.51 19.36 7.38 36.66 15.33 51.64 23.77 1.17.65 2.33 1.31 3.47 1.98 39.15 22.8 61.44 49.01 61.44 76.9Z"
          className="cls-6hol1"
        />
        <path
          d="M996.57 651.97c-13.03 0-25.98.27-38.83.82-370.08 15.54-663.95 251.89-663.95 541.17 0 174.47 106.89 329.68 272.93 428.8 118.82 70.96 267.94 113.18 429.85 113.18h2c159.42-.35 306.36-41.62 424.07-110.93 168.19-99.02 276.7-255.26 276.7-431.05 0-299.33-314.64-541.99-702.77-541.99Zm-407.59 849.2V886.75c0-46.25 37.49-83.75 83.74-83.75h614.42c46.26 0 83.75 37.5 83.75 83.75v614.42c0 38.3-25.71 70.59-60.82 80.56a83.822 83.822 0 0 1-22.93 3.18H672.72c-2.6 0-5.17-.12-7.71-.35-42.64-3.89-76.03-39.74-76.03-83.39Z"
          style={{
            fill: "#ff6d28",
          }}
        />
        <path
          d="M1706.21 1193.96c0 299.33-314.64 541.99-702.78 541.99-144.55 0-278.89-33.65-390.59-91.36 24.07 10.64 449.14 190.84 764.04-47.76 38.53-29.19 242.09-183.44 236.81-424.03-4.46-203.43-155.32-335.6-179.62-356.23-190.91-162.06-478.27-151.84-476.48-163.46.53-3.45 25.66-1.14 45.84-1.14 388.14 0 702.78 242.65 702.78 541.98Z"
          className="cls-6hol1"
        />
        <ellipse
          cx={992.65}
          cy={562.05}
          className="cls-6hol1"
          rx={494.89}
          ry={159.22}
        />
        <path
          d="M1323.16 480.02c16.81 24.52 6.07 58.4-21.81 68.72-73.22 27.12-179.31 55.4-308.7 55.4-64.4 0-170.75-7.01-293.15-49.79-31.26-10.93-40.9-50.39-18.28-74.57 31.25-33.4 65.66-77.19 95.97-132.53 35.33-64.5 54.51-125.42 65.2-174.23 6.11-27.91 35.89-43.59 62.28-32.64 67.24 27.92 152.14 72.25 238.14 142.86 82.18 67.48 140.41 138.47 180.36 196.76Z"
          style={{
            fill: "#871ae5",
          }}
        />
        <path
          d="M1323.16 480.02c-39.95-58.29-98.18-129.28-180.36-196.76-86-70.62-170.89-114.95-238.14-142.86-18.05-7.49-37.69-2.52-50.25 10.31 46.65 16.51 107.36 42.74 171.94 85.25 59.57 39.21 222.85 146.69 203.05 224.89-19.37 76.51-209.62 107.7-355.05 75.71-78.55-17.28-137.67-51.58-174.66-77.37-5.98 3.89-10.82 12.43-18.48 20.61-22.62 24.18-12.98 63.64 18.28 74.57 122.4 42.79 228.75 49.79 293.15 49.79 129.39 0 235.48-28.28 308.7-55.4 27.88-10.33 38.62-44.2 21.81-68.72Z"
          style={{
            fill: "#6d2bb2",
          }}
        />
        {children}
      </g>
    </svg>
  );
}
